import {LoadingPlaceholder} from 'src/components';

export const Spinner = () => (
  <div style={{position: 'relative', padding: '0.1rem 1rem 0', marginTop: '0.4rem'}}>
    <LoadingPlaceholder position='absolute' scale={0.5} title="Updating Comparison" />
  </div>
);
